import { render, staticRenderFns } from "./ConnectCryptoDotCom.vue?vue&type=template&id=7ab5a47a&"
import script from "./ConnectCryptoDotCom.vue?vue&type=script&lang=js&"
export * from "./ConnectCryptoDotCom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports